import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ClassMembership, type ClassMembershipStatus } from '../class-membership.js';
import { ClassRoom } from '../classroom.js';
import { Teacher } from '../teacher.js';

export const getRosterForClassQuery = registerQuery({
  operationName: 'getRosterForClassQuery',
  type: () => [ClassMembership],
  params: [
    { name: 'classRoomID', type: () => String },
    { name: 'status', type: () => String },
  ],

  resolve:
    (classRoomID: string, status?: ClassMembershipStatus) =>
    async (_gqlFields: BaseQLSelectionSet<ClassMembership>): Promise<ClassMembership[]> => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) return [];

    const teacherCollection = await getCollection(Teacher);
    const teacher = await teacherCollection.findOne({ userID: currentUser._id });
    if (!teacher) return [];

    const classroomCollection = await getCollection(ClassRoom);
    const classroom = await classroomCollection.findOne({ _id: classRoomID });
    if (!classroom || classroom.teacherID !== teacher._id) {
      throw new Error('Nicht autorisiert: Diese Klasse gehört dir nicht');
    }

    const membershipCollection = await getCollection(ClassMembership);
    const query: Record<string, unknown> = { classRoomID };
    if (status) query.status = status;

    const memberships = await membershipCollection.find(query).sort({ requestedAt: -1 }).toArray();

    return memberships as ClassMembership[];
  },
});
